export default __webpack_public_path__ + "static/media/TicTac-Learn-Website_element-24-1.c52d3e30.png";